'use strict';
import React from "react";
import {withRouter} from "react-router";
import Confirm from "./Confirm";


const confirm = (message, options) =>{
	let cleanup, component, props, wrapper;
	if (options == null) {
		options = {};
	}
	props = $.extend({
		message: message,
		hookToTop: true
	}, options);
	wrapper = document.body.appendChild(document.createElement('div'));
	component = React.render(<Confirm {...props}/>, wrapper);
	cleanup = function() {
		React.unmountComponentAtNode(wrapper);
		return setTimeout(function() {
			return wrapper.remove();
		});
	};
	return component.promise.always(cleanup).promise();
};


const unsavedDataDialogHandler = function (component) {

	const message = 'Het huidig formulier-gedeelte bevat nog niet bewaarde wijzigingen. Ben je zeker dat je wil verder gaan, en de wijzigingen verliest?';

	/*class ConfirmLeaveComponent extends React.Component { }*/

	function newFunction() {
		return component.apply(this, arguments);
	}

	let prototype = Object.create(component.prototype);

	prototype.componentDidMount = function () {
		this.setState({hasUnsavedChanges: false});
		if (component.prototype.componentDidMount) {
			return component.prototype.componentDidMount.apply(this, arguments);
		}
		else return null;
	};

	prototype.componentWillUpdate = function () {
		this.props.router.setRouteLeaveHook(this.props.route,
			() => {
				if (this.state.hasUnsavedChanges)
					return message;
			});
	};

	prototype.onCancel = function () {
		return component.prototype.onCancel.apply(this, arguments);
	};


	newFunction.prototype = prototype;
	return withRouter(newFunction);
};

export default unsavedDataDialogHandler;
